import { assessmentQuestionTypes } from '../types';

const initialState = {
    question_id: '',
    loading: false,
    success: '',
    error: '',
    text: ''
}

export function assessmentQuestionReducer(state = initialState, action){
    switch (action.type){
        case assessmentQuestionTypes.ASSESSMENT_MCQ_QUESTION_PAGE_REFRESH:
            return {
                ...state,
                question_id: '',
                loading: false,
                success: '',
                error: '',
                text: ''
            }
        case assessmentQuestionTypes.CREATE_ASSESSMENT_MCQ_QUESTION:
            return {
                ...state,
                loading: true,
                text: 'Creating MCQ Question'
            }
        case assessmentQuestionTypes.CREATE_ASSESSMENT_MCQ_QUESTION_REQUEST:
            return {
                ...state,
                loading: true
            }
        case assessmentQuestionTypes.CREATE_ASSESSMENT_MCQ_QUESTION_SUCCESS:
            return {
                ...state,
                question_id: action.question.question_id,
                loading: false,
                success: 'Question and answer added successfully'
            }
        case assessmentQuestionTypes.CREATE_ASSESSMENT_MCQ_QUESTION_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            }
        case assessmentQuestionTypes.ASSESSMENT_DESCRIPTIVE_QUESTION_PAGE_REFRESH:
                    return {
                        ...state,
                        question_id: '',
                        loading: false,
                        success: '',
                        error: '',
                        text: ''
                    }
        case assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION:
            return {
                ...state,
                loading: true,
                text: 'Creating Question'
            }
        case assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION_REQUEST:
            return {
                ...state,
                loading: true
            }
        case assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION_SUCCESS:
            return {
                ...state,
                question_id: action.question.question_id,
                loading: false,
                success: 'Question created successfully'
            }
        case assessmentQuestionTypes.CREATE_ASSESSMENT_DESCRIPTIVE_QUESTION_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            }
        case assessmentQuestionTypes.ADD_ASSESSMENT_QUESTION_ANSWER:
            return {
                ...state,
                loading: false,
                text: 'Add answer',
                error: '',
                success: ''
            }
        case assessmentQuestionTypes.ADD_ASSESSMENT_QUESTION_ANSWER_REQUEST:
            return {
                ...state,
                loading: true,
                text: 'Adding Answer'
            }
        case assessmentQuestionTypes.ADD_ASSESSMENT_QUESTION_ANSWER_SUCCESS:
            return {
                ...state,
                loading: false,
                success: 'Answer added successfully'
            }
        case assessmentQuestionTypes.ADD_ASSESSMENT_QUESTION_ANSWER_FAILURE:
            return {
                ...state,
                error: action.error,
                loading: false
            }
        default:
            return state
    }
}
